export const DealerRoleName = {
  FRANCHISED_DEALER: 'Franchised Dealer',
  INDEPENDENT_DEALER: 'Independent Dealer',
};
